var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12.056,
  height: 10.249,
  viewBox: "0 0 12.056 10.249"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.7,4.436H9.667s0,0,0,0L6.287,1.183A.687.687,0,1,1,7.24.192l4.6,4.425a.687.687,0,0,1,0,.991l-4.63,4.448a.687.687,0,0,1-.953-.991l3.381-3.25s0,0,0,0H.687A.688.688,0,0,1,0,5.167.7.7,0,0,1,.7,4.436Z",
  transform: "translate(0 0)",
  fill: "#36c626"
}))));
export default __webpack_public_path__ + "static/media/arrowright.2ad9fdfe.svg";
export { SvgComponent as ReactComponent };